import type { RoundingMode } from 'big.js';
import Big from 'big.js';

export function isDecimal(number: string, decimal: number) {
  // if (!isNumber(number)) {
  //   return false;
  // }

  const regex = new RegExp(`^([1-9][0-9]*\\.?[0-9]{0,${decimal}}|0\\.[0-9]{0,${decimal}}|0)$`);

  if (!regex.test(number)) {
    return false;
  }

  return true;
}

export function gt(num1: number | string, num2: number | string) {
  return Number(num1) > Number(num2);
}

export function toDisplayDenomAmount(number: string | number, decimal: number) {
  return times(number, pow(10, -decimal), decimal);
}

export function pow(base: number | string, exponent: number) {
  return new Big(base).pow(exponent).toString();
}

export function times(num1: number | string, num2: number | string, toFix?: number) {
  if (!num1 || !num2) return '0';

  if (toFix !== undefined) {
    return new Big(num1).times(num2).toFixed(toFix, 0);
  }

  return new Big(num1).times(num2).toString();
}

export function plus(num1: number | string, num2: number | string, toFix?: number) {
  if (toFix !== undefined) {
    return new Big(num1).plus(num2).toFixed(toFix, 0);
  }

  return new Big(num1).plus(num2).toString();
}

export function toBaseDenomAmount(number: string | number, decimal: number) {
  return times(number, pow(10, decimal), 0);
}

export function ceil(num: string | number): string {
  const splitedNum = String(num).split('.');

  if (gt(splitedNum?.[1] || '0', '0')) {
    return (Number(num) + 1).toFixed(0);
  }

  return Number(num).toFixed(0);
}

export function minus(number1: string | number, number2: string | number) {
  return String(Number(number1) - Number(number2));
}

export function fix(number: string, decimal?: number, optional: RoundingMode = 0) {
  return Big(number).toFixed(decimal, optional);
}

export function trimZeros(number: string | number, fixNum?: number) {
  if (fixNum) {
    const fixedNumber = fix(String(number), fixNum);

    let strNumber = String(fixedNumber).trim();

    if (strNumber.includes('.')) {
      strNumber = strNumber.replace(/0+$/, '');
      strNumber = strNumber.replace(/\.$/, ''); // 소수점만 남은 경우 제거
    }

    return strNumber;
  }

  let strNumber = String(number).trim();

  if (strNumber.includes('.')) {
    strNumber = strNumber.replace(/0+$/, '');
    strNumber = strNumber.replace(/\.$/, ''); // 소수점만 남은 경우 제거
  }

  return strNumber;
}
